import useInfinitiveScrollableWire from '../../shared/infinitive-scrollable-wires-hook';

const INIT = 9;

const useScrollableWires = props => useInfinitiveScrollableWire({
  ...props,
  isScrollable: false,
  initNumber: INIT,
  entityName: 'wires',
});

export default useScrollableWires;
